import type { CarouselItem, CarouselLlmProgress } from "@/lib/api";
import { clockLabel, elapsedSec, useNowTick } from "@/lib/useNowTick";

function displayEvent(event?: string): string {
  if (event === "alive") return "czekam na znak";
  if (event === "prompt_ready") return "gotowe zapytanie";
  if (event === "call") return "wysyłam";
  if (event === "first_token") return "leci tekst";
  if (event === "response") return "koniec strzału";
  return event || "?";
}

export default function LlmJobDebug({
  item,
  progress,
  className,
}: {
  item?: Pick<CarouselItem, "id" | "short_id" | "llm_status" | "llm_detail" | "celery_task_id"> | null;
  progress?: CarouselLlmProgress | null;
  className?: string;
}) {
  const running = Boolean(progress?.started_at) && progress?.phase !== "done";
  const now = useNowTick(running);
  const stall = progress?.updated_at
    ? elapsedSec(progress.updated_at, now)
    : Number(progress?.stall_sec || 0);
  const hint = (progress?.hint || "").trim();
  if (!item && !progress) return null;
  return (
    <details open className={className}>
      <summary className="cursor-pointer text-xs font-medium text-muted-foreground">
        Debug generacji
        {progress?.last_event ? ` · ${displayEvent(progress.last_event)}` : ""}
        {stall ? ` · cisza ${clockLabel(stall)}` : ""}
      </summary>
      <dl className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1 text-[11px]">
        <div>
          <dt className="text-muted-foreground">status</dt>
          <dd className="font-medium">{item?.llm_status || "brak"}</dd>
        </div>
        <div>
          <dt className="text-muted-foreground">krok</dt>
          <dd className="font-medium">{progress?.step || "brak"}</dd>
        </div>
        <div>
          <dt className="text-muted-foreground">job</dt>
          <dd className="font-medium">{(progress?.job_steps || []).join(" → ") || "jeden strzał"}</dd>
        </div>
        <div>
          <dt className="text-muted-foreground">faza</dt>
          <dd className="font-medium">{progress?.phase || "brak"}</dd>
        </div>
        <div>
          <dt className="text-muted-foreground">model</dt>
          <dd className="break-all font-medium">{progress?.model || "jeszcze nie"}</dd>
        </div>
        <div>
          <dt className="text-muted-foreground">znaki</dt>
          <dd className="font-medium">
            {Number(progress?.received_chars || 0)} / ~{Number(progress?.expected_chars || 0)}
          </dd>
        </div>
        <div>
          <dt className="text-muted-foreground">celery</dt>
          <dd className="break-all font-medium">{item?.celery_task_id || "brak / wątek API"}</dd>
        </div>
      </dl>
      {Number(progress?.received_chars || 0) <= 0 && progress?.phase && progress.phase !== "done" ? (
        <p className="mt-2 text-xs text-muted-foreground">Model myśli, to nie ponowienie.</p>
      ) : null}
      {hint ? <p className="mt-2 text-xs text-warning">{hint}</p> : null}
      {item?.llm_detail && item.llm_detail !== hint ? (
        <p className="mt-1 text-[11px] text-muted-foreground">{item.llm_detail}</p>
      ) : null}
    </details>
  );
}
